export default __webpack_public_path__ + "fcf20db3f13bdfd636c3fbb5c285fd49.png";